import { useEffect, useState, useRef } from "react";

// material-ui

import "react-quill/dist/quill.snow.css";
import { useFormik, Form, FormikProvider } from "formik";
import {
  Box,
  Button,
  FormControl,
  DialogTitle,
  Divider,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  DialogContent,
  DialogActions,
  CircularProgress,
  Typography,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";

// third-party
import _ from "lodash";
import * as Yup from "yup";

// project imports

import CircularWithPath from "components/@extended/progress/CircularWithPath";

import { openSnackbar } from "api/snackbar";

// assets

// types
import { SnackbarProps } from "types/snackbar";

import { useAppDispatch } from "hooks";

import {
  addNewTranslation,
  editTranslation,
  getOneTranslations,
} from "store/actions/main/translations";
import { getAllTranslationsCategory } from "store/actions/main/translationCategory";
import { FormattedMessage, useIntl } from "react-intl";
import { TranslationsModel } from "model/translations";
// constant

// ==============================|| TRANSLATION ADD / EDIT - FORM ||============================== //
const getInitialValues = (customer: TranslationsModel | null) => {
  if (customer) {
    return {
      en_name: customer.en_name || "",
      ar_name: customer.ar_name || "",
      key: customer.key || "",
    };
  } else {
    return {
      en_name: "",
      ar_name: "",
      key: "",
      translation_category: "",
    };
  }
};
const FormPageManagmentTranslation = ({
  customer,
  id,
  closeModal,
  fetchData,
  setLoading,
  loading,
}: {
  loading: any;
  setLoading: any;
  fetchData: any;
  id: number;
  customer: TranslationsModel;
  closeModal: () => void;
}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();

  // Split the pathname into segments using "/"

  // Extract the resume ID (second-to-last segment) and user ID (last segment)

  const [translationCategories, settranslationCategories] = useState([]);
  const [selectedCategoryTranslatoion, setselectedCategoryTranslatoion] =
    useState<any>(null);


  useEffect(() => {
    dispatch(getAllTranslationsCategory()).then((action) => {
      const data = action.payload;
      console.log(data, "translation category");
      settranslationCategories(data);
    });
  }, [dispatch]);


  const validationSchema = Yup.object().shape({
    ar_name: Yup.string().required("Arabic name is required"),
    key: Yup.string().required("Key is required"),
  });

  const formik = useFormik({
    initialValues: getInitialValues(customer!),
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (customer) {
          // Dispatch editCategories action if customer exists
          await dispatch(
            editTranslation({
              id: customer.id || 0,
              data: {
                ar_name: values.ar_name,
                en_name: values.en_name,
                key: values.key,
                translation_category_id: selectedCategoryTranslatoion,
              },
            })
          ).then((action) => {
            fetchData();
            if (action.type === "basicInfo/editTitle/fulfilled") {
              openSnackbar({
                open: true,
                message: "Title edited successfully",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                variant: "alert",
                alert: {
                  color: "success",
                },
              } as SnackbarProps);
              setSubmitting(false);
              closeModal();
            }
          });
        } else {
          // Dispatch create newCat action if no customer exists
          await dispatch(
            addNewTranslation({
              ar_name: values.ar_name,
              key: values.key,
              en_name: values.en_name,
              translation_category_id: selectedCategoryTranslatoion,
            })
          ).then((action) => {
            fetchData();
            if (action.type === "basicInfo/addTitle/fulfilled") {
              openSnackbar({
                open: true,
                message: "Title added successfully",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                variant: "alert",
                alert: {
                  color: "success",
                },
              } as SnackbarProps);
              setSubmitting(false);
              closeModal();
            }
          });
        }
        closeModal();
      } catch (error) {
        console.error(error);
      }
    },
  });
  const handleChange = (event: React.ChangeEvent<any>) => {
    const { name, value, type, checked } = event.target;

    // Handle different input types
    const newValue = type === "checkbox" ? checked : value;

    console.log(newValue, "new value");

    console.log(name, "name");

    // Update profileData state with the new value

    // Toggle military service field based on selected gender
  };
  console.log(customer, "customer");
  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;

  if (loading)
    return (
      <Box sx={{ p: 5 }}>
        <Stack direction="row" justifyContent="center">
          <CircularWithPath />
        </Stack>
      </Box>
    );

  return (
    <>
      <FormikProvider value={formik}>
        <LocalizationProvider>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <DialogTitle
              style={{
                textAlign: "center",
                fontSize: "22px",
                fontWeight: "bold",
                color: "rgb(22, 119, 255)",
                marginBottom: "10px",
              }}
            >
              {id ? <FormattedMessage id="Edit Translation" />:  <FormattedMessage id="New Translation" />}
            </DialogTitle>
            <Divider />

            <DialogContent sx={{ p: 2.5 }}>
              <Grid item xs={12} md={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="en_name">
                        <FormattedMessage id="Key" />
                      </InputLabel>
                      <TextField
                        fullWidth
                        name="key" // Add the name attribute
                        {...getFieldProps("key")}
                       placeholder={intl.formatMessage({
                        id: "Enter English Name",
                        defaultMessage: "Enter Key",
                      })}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="en_name">
                        <FormattedMessage id="English Name" />
                      </InputLabel>
                      <TextField
                        fullWidth
                        name="en_name" // Add the name attribute
                        {...getFieldProps("en_name")}
                      placeholder={intl.formatMessage({
                        id: "Enter English Name",
                        defaultMessage: "Enter English Name",
                      })}
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="customr-package_validity">
                        <FormattedMessage id="Arabic Name" />
                      </InputLabel>
                      <TextField
                        fullWidth
                        {...getFieldProps("ar_name")}
                        // Add the name attribute

                         placeholder={intl.formatMessage({
                        id: "Enter Arabic Name",
                        defaultMessage: "Enter Arabic Name",
                      })}
                      />
                    </Stack>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="lang">
                        <FormattedMessage id="Scope" />
                      </InputLabel>

                      <FormControl fullWidth>
                        {translationCategories &&
                        translationCategories.length > 0 ? (
                          <Select
                            id="translation_category"
                            value={
                              selectedCategoryTranslatoion ??
                              customer?.translation_category?.id ??
                              ""
                            }
                            onChange={(e) => {
                              console.log("e.target.value", e.target.value);
                              setselectedCategoryTranslatoion(e.target.value);
                            }}
                            name="translation_category"
                          >
                            {translationCategories.map((category: any) => (
                              <MenuItem key={category.id} value={category.id}>
                                {category?.name}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : (
                          <CircularProgress size="30px" />
                        )}
                      </FormControl>
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>

            <Divider />
            <DialogActions sx={{ p: 2.5 }}>
              <Grid container justifyContent="center" alignItems="center">
                <Stack direction="row" spacing={2} sx={{ width: 1 }}>
                  <Grid item md={2} />
                  <Grid item md={4}>
                   
                      {customer ? (
                        <Button fullWidth type="submit" variant="contained">
                          {isSubmitting ? (
                            <CircularProgress
                              size="1.5rem"
                              style={{ color: "white" }}
                            />
                          ) : (
                            <FormattedMessage id="Update" />
                          )}
                        </Button>
                      ) : (
                        <Button fullWidth type="submit" variant="contained">
                          {isSubmitting ? (
                            <CircularProgress
                              size="1.5rem"
                              style={{ color: "white" }}
                            />
                          ) : (
                            <FormattedMessage id="Submit" />
                          )}
                        </Button>
                      )}
                   
                  </Grid>
                  <Grid item md={4}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="outlined"
                      onClick={closeModal}
                    >
                      <FormattedMessage id="Cancel" />
                    </Button>
                  </Grid>
                  <Grid item md={2} />
                </Stack>
              </Grid>
            </DialogActions>
            <Divider />
          </Form>
        </LocalizationProvider>
      </FormikProvider>
    </>
  );
};

export default FormPageManagmentTranslation;
